import createHTMLElement from './create-element.js';

export default (src, onLoad = () => {}, parent = document.head, async = true) => {
  const script = createHTMLElement(`script`, { src, async });
  script.onload = onLoad;
  parent.appendChild(script);
  return parent;
};
